/**
 * Estimates server time from HTTP Date headers so countdowns / progress stay aligned
 * when the client wall clock is skewed. Falls back to local time if no header yet.
 */

let serverClockOffsetMs = 0
let hasServerClockSample = false

/** Call when an HTTP response is received (e.g. axios interceptor). */
export function recordServerTimeFromResponseDateHeader(
  dateHeader: string | string[] | undefined | null
): void {
  if (dateHeader == null) return
  const raw = Array.isArray(dateHeader) ? dateHeader[0] : dateHeader
  if (!raw || typeof raw !== 'string') return
  const serverMs = Date.parse(raw)
  if (!Number.isFinite(serverMs)) return
  const clientMs = Date.now()
  serverClockOffsetMs = serverMs - clientMs
  hasServerClockSample = true
}

export function hasServerClockOffset(): boolean {
  return hasServerClockSample
}

/** Current time in the server's frame (ms), best-effort from last response Date header. */
export function getAlignedNowMs(): number {
  return Date.now() + serverClockOffsetMs
}
